import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageSimpleController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageSimpleController.php:19
* @route '/product-page/{configurableProduct}/{product}/simple'
*/
const ProductPageSimpleController = (args: { configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } } | [configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageSimpleController.url(args, options),
    method: 'post',
})

ProductPageSimpleController.definition = {
    methods: ["post"],
    url: '/product-page/{configurableProduct}/{product}/simple',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageSimpleController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageSimpleController.php:19
* @route '/product-page/{configurableProduct}/{product}/simple'
*/
ProductPageSimpleController.url = (args: { configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } } | [configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            configurableProduct: args[0],
            product: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        configurableProduct: typeof args.configurableProduct === 'object'
        ? args.configurableProduct.url_key
        : args.configurableProduct,
        product: typeof args.product === 'object'
        ? args.product.sku
        : args.product,
    }

    return ProductPageSimpleController.definition.url
            .replace('{configurableProduct}', parsedArgs.configurableProduct.toString())
            .replace('{product}', parsedArgs.product.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageSimpleController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageSimpleController.php:19
* @route '/product-page/{configurableProduct}/{product}/simple'
*/
ProductPageSimpleController.post = (args: { configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } } | [configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ProductPageSimpleController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageSimpleController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageSimpleController.php:19
* @route '/product-page/{configurableProduct}/{product}/simple'
*/
const ProductPageSimpleControllerForm = (args: { configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } } | [configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageSimpleController.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\ProductPage\ProductPageSimpleController::__invoke
* @see Http/Controllers/Web/ProductPage/ProductPageSimpleController.php:19
* @route '/product-page/{configurableProduct}/{product}/simple'
*/
ProductPageSimpleControllerForm.post = (args: { configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } } | [configurableProduct: string | number | { url_key: string | number }, product: string | number | { sku: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ProductPageSimpleController.url(args, options),
    method: 'post',
})

ProductPageSimpleController.form = ProductPageSimpleControllerForm

export default ProductPageSimpleController